/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { Icon } from '../../Icon';
import * as styles from './index.styles';

class ArrowButtons extends SafePureComponent {
  displayName = 'ArrowButtons';

  propTypes = {
    onPrev: PropTypes.func,
    onNext: PropTypes.func,
  };

  safeRender() {
    const { onNext, onPrev, innerCss = {} } = this.props;

    return (
      <div data-testid="container" css={[styles.container, innerCss.container]}>
        <button css={styles.button} data-testid="prev" onClick={onPrev}>
          {/* TODO: Use icomoon instead */}
          <Icon name="arrow-left" customCss={styles.icon} />
        </button>
        <button css={styles.button} data-testid="next" onClick={onNext}>
          {/* TODO: Use icomoon instead */}
          <Icon name="arrow-right" customCss={styles.icon} />
        </button>
      </div>
    );
  }
}

ArrowButtons.displayName = 'SwiperComponents/ArrowButtons';

export default ArrowButtons;
